import React from "react";

// Style \\
import "../../assets/styles/sections/getInTouch.scss";

//  Icons \\
import { LiaPhoneVolumeSolid } from "react-icons/lia";
import { MdOutlineMailOutline } from "react-icons/md";
import { CiLocationOn } from "react-icons/ci";
import { BsClock } from "react-icons/bs";

const GetInTouch = () => {
  return (
    <section className="getInTouch">
      <div className="container">
        <div className="getInTouch_items">
          <div className="form_box">
            <div className="title">
              <p>Get in touch</p>
              <h3>Contact</h3>
            </div>

            <form>
              <div className="first">
                <div className="input">
                  <input type="text" className="other" placeholder="Name" />
                </div>

                <div className="input">
                  <input
                    type="tel"
                    defaultValue="+998 "
                    className="other"
                    placeholder="Phone"
                  />
                </div>
              </div>

              <div className="input">
                <select name="gender" id="">
                  <option value="Gender" selected>
                    Gender
                  </option>
                  <option value="Male">Male</option>
                  <option value="Famale">Female</option>
                </select>
              </div>

              <div className="textAreaNew">
                <textarea
                  name="Message"
                  placeholder="Message"
                  cols="30"
                  rows="11"
                ></textarea>
              </div>

              <div className="button_box">
                <button>Submit</button>
              </div>
            </form>
          </div>

          <div className="contact_items_cardBox">
            <div className="cards">
              <div className="card_items">
                <div className="card_items_icons">
                  <LiaPhoneVolumeSolid className="icons" />
                </div>

                <div className="card_items_title">
                  <h4>Emergency</h4>
                </div>

                <div className="card_items_tel">
                  <p>(237) 681-812-255</p>
                  <p>(237) 666-331-894</p>
                </div>
              </div>
            </div>

            <div className="cards">
              <div className="card_items">
                <div className="card_items_icons">
                  <CiLocationOn className="icons" />
                </div>

                <div className="card_items_title">
                  <h4>Location</h4>
                </div>

                <div className="card_items_tel">
                  <p>0123 Some place</p>
                  <p>9876 Some country</p>
                </div>
              </div>
            </div>

            <div className="cards">
              <div className="card_items">
                <div className="card_items_icons">
                  <MdOutlineMailOutline className="icons" />
                </div>

                <div className="card_items_title">
                  <h4>Email</h4>
                </div>

                <div className="card_items_tel">
                  <p>fildineeesoe@gmil.com</p>
                  <p>myebstudios@gmail.com</p>
                </div>
              </div>
            </div>

            <div className="cards">
              <div className="card_items">
                <div className="card_items_icons">
                  <BsClock className="icons" />
                </div>

                <div className="card_items_title">
                  <h4>Working Hours</h4>
                </div>

                <div className="card_items_tel">
                  <p>Mon-Sat 09:00-20:00</p>
                  <p>Sunday Emergency only</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GetInTouch;
